import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import { getSettingHelpCenterChatAvailableLocales } from "@faire/help-center-utils/settings/getSettingHelpCenterChatAvailableLocales";
export var isLocaleChatSupported = function isLocaleChatSupported(locale) {
  return getSettingHelpCenterChatAvailableLocales().some(function (supportedLocale) {
    return supportedLocale.country === locale.country && supportedLocale.language === locale.language;
  });
};